// deno-fmt-ignore-file
async function* CreateAsyncIterator() { }
export function FromAsyncIterator(context, type) {
    return CreateAsyncIterator();
}
